document.addEventListener('DOMContentLoaded', function () {
  const VAT_RATE = 1.2;
  let scheduled = false;

  function parsePrice(text) {
    if (!text) return NaN;

    return parseFloat(
      String(text)
        .replace(/,/g, '')
        .replace(/[^\d.]/g, '')
        .trim()
    );
  }

  function formatGBP(value) {
    return '£' + value.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function applyVatToFbtPrices() {
    const selectors = [
      '.boost-sd__recommendation-bundle-left .boost-sd__format-currency',
      '.boost-sd__recommendation-bundle-right .boost-sd__recommendation-bundle-total-number'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
      const text = (el.textContent || '').trim();
      if (!text) return;

      // Store original ex-VAT value once per element
      if (!el.dataset.boostExVatOriginal) {
        const parsed = parsePrice(text);
        if (isNaN(parsed) || parsed <= 0) return;
        el.dataset.boostExVatOriginal = parsed;
      }

      const exVat = parseFloat(el.dataset.boostExVatOriginal);
      if (isNaN(exVat) || exVat <= 0) return;

      const incVatText = formatGBP(exVat * VAT_RATE);

      if (el.textContent.trim() !== incVatText) {
        el.textContent = incVatText;
      }
    });
  }

  function scheduleApplyVat() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      applyVatToFbtPrices();
      scheduled = false;
    });
  }

  // Initial pass
  applyVatToFbtPrices();

  // Watch for Boost re-renders
  const observer = new MutationObserver(function () {
    scheduleApplyVat();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Extra delayed passes for async widget loads
  setTimeout(applyVatToFbtPrices, 300);
  setTimeout(applyVatToFbtPrices, 800);
  setTimeout(applyVatToFbtPrices, 1500);
  setTimeout(applyVatToFbtPrices, 2500);
});